<template>
  <v-app>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-toolbar color="indigo" dark flat>
        <v-toolbar-title class="font-weight-bold">
          <v-icon size="25">mdi-account-cog-outline </v-icon>
          師資設定
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="goHome">
              <v-icon>mdi-home</v-icon>
            </v-btn>
          </template>
          <span>回到首頁</span>
        </v-tooltip>
        <template v-slot:extension>
          <v-tabs v-model="tab" grow>
            <v-tab>專任教師</v-tab>
            <v-tab>兼任教師</v-tab>
            <v-tab>合聘師資</v-tab>
            <v-tab>國際師資</v-tab>
            <v-tab>業界師資</v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <v-tabs-items v-model="tab">
        <!--專任教師-->
        <v-tab-item>
          <v-container fluid v-if="tab == 0">
            <v-row no-gutters>
              <v-col cols="5">
                <v-card elevation="2">
                  <v-card-title class="text-h5 font-weight-bold ">全部教師 <v-spacer></v-spacer>
                    <v-text-field append-icon="mdi-account-search-outline " label="Search" placeholder="輸入教師姓名或證號"
                      v-model="seacher" rounded dense filled hide-details @click:append="searchKeyWorld"
                      @keyup.enter="searchKeyWorld"></v-text-field>
                  </v-card-title>

                  <v-card-text style="height:800px;overflow:auto;">

                    <v-list two-line v-if="seacherState == 0">
                      <template v-for="(item, index) in resultTeachers">
                        <v-list-item :key="item.userId">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.name"></v-list-item-title>

                            <v-list-item-subtitle class="text--primary" v-text="item.teno"></v-list-item-subtitle>

                            <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="addCurrentAry(item, 1)">mdi-plus</v-icon>
                          </v-list-item-icon>
                        </v-list-item>

                        <v-divider v-if="index < resultTeachers.length - 1" :key="index"></v-divider>
                      </template>
                    </v-list>
                    <!-- alert -->
                    <v-alert type="info" text v-else-if="seacherState == 1">請輸入於上方輸入教師名稱或證號</v-alert>
                    <v-alert type="info" text v-else-if="seacherState == 2">查無資料</v-alert>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="2">
                <v-row no-gutters justify="center" style="height:900px;">
                  <v-icon size="40">mdi-arrow-left-right </v-icon>
                </v-row>
              </v-col>

              <v-col cols="5">
                <v-card elevation="2">
                  <v-card-title class="text-h5 font-weight-bold "> 當前教師</v-card-title>
                  <v-card-text>
                    <v-list two-line>
                      <template v-for="(item, index) in currentFTTeachers">
                        <v-list-item :key="item.userId">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.name"></v-list-item-title>

                            <v-list-item-subtitle class="text--primary" v-text="item.epno"></v-list-item-subtitle>

                            <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="upCurrentAry(index, 1)">mdi-arrow-up </v-icon>
                          </v-list-item-icon>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="downCurrentAry(index, 1)">mdi-arrow-down </v-icon>
                          </v-list-item-icon>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="removeCurrentAry(index, 1)">mdi-minus</v-icon>
                          </v-list-item-icon>
                        </v-list-item>

                        <v-divider v-if="index < currentFTTeachers.length - 1" :key="index"></v-divider>
                      </template>
                    </v-list>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="indigo" @click="saveData(1)">save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <!-- 兼任教師 -->
        <v-tab-item>
          <v-container fluid v-if="tab == 1">
            <v-row no-gutters>
              <v-col cols="5">
                <v-card elevation="2">
                  <v-card-title class="text-h5 font-weight-bold ">全部教師 <v-spacer></v-spacer>
                    <v-text-field append-icon="mdi-account-search-outline " label="Search" placeholder="輸入教師姓名或證號"
                      v-model="seacher" rounded dense filled hide-details @click:append="searchKeyWorld"
                      @keyup.enter="searchKeyWorld"></v-text-field>
                  </v-card-title>

                  <v-card-text style="height:800px;overflow:auto;">

                    <v-list two-line v-if="seacherState == 0">
                      <template v-for="(item, index) in resultTeachers">
                        <v-list-item :key="item.userId">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.name"></v-list-item-title>

                            <v-list-item-subtitle class="text--primary" v-text="item.teno"></v-list-item-subtitle>

                            <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="addCurrentAry(item, 2)">mdi-plus</v-icon>
                          </v-list-item-icon>
                        </v-list-item>

                        <v-divider v-if="index < resultTeachers.length - 1" :key="index"></v-divider>
                      </template>
                    </v-list>
                    <!-- alert -->
                    <v-alert type="info" text v-else-if="seacherState == 1">請輸入於上方輸入教師名稱或證號</v-alert>
                    <v-alert type="info" text v-else-if="seacherState == 2">查無資料</v-alert>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="2">
                <v-row no-gutters justify="center" style="height:900px;">
                  <v-icon size="40">mdi-arrow-left-right </v-icon>
                </v-row>
              </v-col>

              <v-col cols="5">
                <v-card elevation="2">
                  <v-card-title class="text-h5 font-weight-bold "> 當前教師</v-card-title>
                  <v-card-text>
                    <v-list two-line>
                      <template v-for="(item, index) in currentPTTeachers">
                        <v-list-item :key="item.userId">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.name"></v-list-item-title>

                            <v-list-item-subtitle class="text--primary" v-text="item.epno"></v-list-item-subtitle>

                            <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="upCurrentAry(index, 2)">mdi-arrow-up </v-icon>
                          </v-list-item-icon>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="downCurrentAry(index, 2)">mdi-arrow-down </v-icon>
                          </v-list-item-icon>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="removeCurrentAry(index, 2)">mdi-minus</v-icon>
                          </v-list-item-icon>
                        </v-list-item>

                        <v-divider v-if="index < currentPTTeachers.length - 1" :key="index"></v-divider>
                      </template>
                    </v-list>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="indigo" @click="saveData(2)">save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <!-- 合聘教師 -->
        <v-tab-item>
          <v-container fluid v-if="tab == 2">
            <v-row no-gutters>
              <v-col cols="5">
                <v-card elevation="2">
                  <v-card-title class="text-h5 font-weight-bold ">全部教師 <v-spacer></v-spacer>
                    <v-text-field append-icon="mdi-account-search-outline " label="Search" placeholder="輸入教師姓名或證號"
                      v-model="seacher" rounded dense filled hide-details @click:append="searchKeyWorld"
                      @keyup.enter="searchKeyWorld"></v-text-field>
                  </v-card-title>

                  <v-card-text style="height:800px;overflow:auto;">

                    <v-list two-line v-if="seacherState == 0">
                      <template v-for="(item, index) in resultTeachers">
                        <v-list-item :key="item.userId">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.name"></v-list-item-title>

                            <v-list-item-subtitle class="text--primary" v-text="item.teno"></v-list-item-subtitle>

                            <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="addCurrentAry(item, 3)">mdi-plus</v-icon>
                          </v-list-item-icon>
                        </v-list-item>

                        <v-divider v-if="index < resultTeachers.length - 1" :key="index"></v-divider>
                      </template>
                    </v-list>
                    <!-- alert -->
                    <v-alert type="info" text v-else-if="seacherState == 1">請輸入於上方輸入教師名稱或證號</v-alert>
                    <v-alert type="info" text v-else-if="seacherState == 2">查無資料</v-alert>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="2">
                <v-row no-gutters justify="center" style="height:900px;">
                  <v-icon size="40">mdi-arrow-left-right </v-icon>
                </v-row>
              </v-col>

              <v-col cols="5">
                <v-card elevation="2">
                  <v-card-title class="text-h5 font-weight-bold "> 當前教師
                    <v-spacer></v-spacer>
                    <v-icon @click="newPerson()">mdi-account-plus </v-icon>
                  </v-card-title>
                  <v-card-text>
                    <v-list two-line>
                      <template v-for="(item, index) in currentJTTeachers">
                        <v-list-item :key="item.userId">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.name"></v-list-item-title>

                            <v-list-item-subtitle class="text--primary" v-text="item.epno"></v-list-item-subtitle>

                            <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="editPerson(index, item)">mdi-account-edit </v-icon>
                          </v-list-item-icon>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="upCurrentAry(index, 3)">mdi-arrow-up </v-icon>
                          </v-list-item-icon>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="downCurrentAry(index, 3)">mdi-arrow-down </v-icon>
                          </v-list-item-icon>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="removeCurrentAry(index, 3)">mdi-minus</v-icon>
                          </v-list-item-icon>
                        </v-list-item>

                        <v-divider v-if="index < currentJTTeachers.length - 1" :key="index"></v-divider>
                      </template>
                    </v-list>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="indigo" @click="saveData(3)">save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <!-- 國際師資 -->
        <v-tab-item>
          <v-container fluid v-if="tab == 3">
            <v-row no-gutters>
              <v-col cols="5">
                <v-card elevation="2">
                  <v-card-title class="text-h5 font-weight-bold ">全部教師 <v-spacer></v-spacer>
                    <v-text-field append-icon="mdi-account-search-outline " label="Search" placeholder="輸入教師姓名或證號"
                      v-model="seacher" rounded dense filled hide-details @click:append="searchKeyWorld"
                      @keyup.enter="searchKeyWorld"></v-text-field>
                  </v-card-title>

                  <v-card-text style="height:800px;overflow:auto;">

                    <v-list two-line v-if="seacherState == 0">
                      <template v-for="(item, index) in resultTeachers">
                        <v-list-item :key="item.userId">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.name"></v-list-item-title>

                            <v-list-item-subtitle class="text--primary" v-text="item.teno"></v-list-item-subtitle>

                            <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="addCurrentAry(item, 4)">mdi-plus</v-icon>
                          </v-list-item-icon>
                        </v-list-item>

                        <v-divider v-if="index < resultTeachers.length - 1" :key="index"></v-divider>
                      </template>
                    </v-list>
                    <!-- alert -->
                    <v-alert type="info" text v-else-if="seacherState == 1">請輸入於上方輸入教師名稱或證號</v-alert>
                    <v-alert type="info" text v-else-if="seacherState == 2">查無資料</v-alert>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="2">
                <v-row no-gutters justify="center" style="height:900px;">
                  <v-icon size="40">mdi-arrow-left-right </v-icon>
                </v-row>
              </v-col>

              <v-col cols="5">
                <v-card elevation="2">
                  <v-card-title class="text-h5 font-weight-bold "> 當前教師
                    <v-spacer></v-spacer>
                    <v-icon @click="newPerson()">mdi-account-plus </v-icon>
                  </v-card-title>
                  <v-card-text>
                    <v-list two-line>
                      <template v-for="(item, index) in currentInTTeachers">
                        <v-list-item :key="item.userId">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.name"></v-list-item-title>

                            <v-list-item-subtitle class="text--primary" v-text="item.epno"></v-list-item-subtitle>

                            <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="editPerson(index, item)">mdi-account-edit </v-icon>
                          </v-list-item-icon>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="upCurrentAry(index, 4)">mdi-arrow-up </v-icon>
                          </v-list-item-icon>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="downCurrentAry(index, 4)">mdi-arrow-down </v-icon>
                          </v-list-item-icon>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="removeCurrentAry(index, 4)">mdi-minus</v-icon>
                          </v-list-item-icon>
                        </v-list-item>

                        <v-divider v-if="index < currentInTTeachers.length - 1" :key="index"></v-divider>
                      </template>
                    </v-list>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="indigo" @click="saveData(4)">save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <!-- 業界師資 -->
        <v-tab-item>
          <v-container fluid v-if="tab == 4">
            <v-row no-gutters>
              <v-col cols="5">
                <v-card elevation="2">
                  <v-card-title class="text-h5 font-weight-bold ">全部教師 <v-spacer></v-spacer>
                    <v-text-field append-icon="mdi-account-search-outline " label="Search" placeholder="輸入教師姓名或證號"
                      v-model="seacher" rounded dense filled hide-details @click:append="searchKeyWorld"
                      @keyup.enter="searchKeyWorld"></v-text-field>
                  </v-card-title>

                  <v-card-text style="height:800px;overflow:auto;">

                    <v-list two-line v-if="seacherState == 0">
                      <template v-for="(item, index) in resultTeachers">
                        <v-list-item :key="item.userId">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.name"></v-list-item-title>

                            <v-list-item-subtitle class="text--primary" v-text="item.teno"></v-list-item-subtitle>

                            <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="addCurrentAry(item, 5)">mdi-plus</v-icon>
                          </v-list-item-icon>
                        </v-list-item>

                        <v-divider v-if="index < resultTeachers.length - 1" :key="index"></v-divider>
                      </template>
                    </v-list>
                    <!-- alert -->
                    <v-alert type="info" text v-else-if="seacherState == 1">請輸入於上方輸入教師名稱或證號</v-alert>
                    <v-alert type="info" text v-else-if="seacherState == 2">查無資料</v-alert>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col cols="2">
                <v-row no-gutters justify="center" style="height:900px;">
                  <v-icon size="40">mdi-arrow-left-right </v-icon>
                </v-row>
              </v-col>

              <v-col cols="5">
                <v-card elevation="2">
                  <v-card-title class="text-h5 font-weight-bold "> 當前教師
                    <v-spacer></v-spacer>
                    <v-icon @click="newPerson()">mdi-account-plus </v-icon>
                  </v-card-title>
                  <v-card-text>
                    <v-list two-line>
                      <template v-for="(item, index) in currentIdTTeachers">
                        <v-list-item :key="item.userId">
                          <v-list-item-content>
                            <v-list-item-title v-text="item.name"></v-list-item-title>

                            <v-list-item-subtitle class="text--primary" v-text="item.epno"></v-list-item-subtitle>

                            <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="editPerson(index, item)">mdi-account-edit </v-icon>
                          </v-list-item-icon>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="upCurrentAry(index, 5)">mdi-arrow-up </v-icon>
                          </v-list-item-icon>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="downCurrentAry(index, 5)">mdi-arrow-down </v-icon>
                          </v-list-item-icon>

                          <v-list-item-icon class="ml-4 mb-0">
                            <v-icon size="30" @click="removeCurrentAry(index, 5)">mdi-minus</v-icon>
                          </v-list-item-icon>
                        </v-list-item>

                        <v-divider v-if="index < currentIdTTeachers.length - 1" :key="index"></v-divider>
                      </template>
                    </v-list>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="indigo" @click="saveData(5)">save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <v-dialog v-model="dialog.show" :max-width="dialog.index == 0 ? 290 : 800">
      <!-- Message -->
      <v-card v-if="dialog.index == 0">
        <v-card-title :class="['white--text', 'text-h6', dialog.type]">
          Message
        </v-card-title>

        <v-card-text class="mt-4 font-weight-black text-h5">
          {{ dialog.msg }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="indigo darken-1" text @click="controllDialog(false, 0, '', 'info')">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
      <!-- form -->
      <v-card v-else-if="dialog.index == 1">
        <v-card-title :class="['white--text', 'text-h6', dialog.type]">
          {{ dialog.mode == 0 ? 'Create new teacher' : 'Edit teacher' }}
        </v-card-title>

        <v-card-text class="mt-4 font-weight-black text-h5">
          <!-- circle avatar -->
          <v-row no-gutters justify="center" class="pt-2 pb-6">
            <v-avatar size="150">
              <!-- <v-img :src="dialog.form.img != null
  ? dialog.form.img.indexOf('pic') != -1
    ? `../../${domain}/${dialog.form.img}`
    : `/manage/members/uploads/${dialog.form.img}`
  : ''" alt="empty"> -->
              <v-img :src="dialog.form.showImg" alt="empty">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-avatar size="150">
                      <v-icon size="150">
                        mdi-account-circle
                      </v-icon>
                    </v-avatar>
                  </v-row>
                </template>
              </v-img>
            </v-avatar>
          </v-row>
          <!--name-->
          <v-row no-gutters justify="space-between">
            <v-text-field outlined dense label="*姓名" v-model="dialog.form.name"
              :rules="[dialog.rules.required, dialog.rules.symbol]"></v-text-field>
          </v-row>
          <!-- title & company -->
          <v-row no-gutters justify="space-between">
            <v-col cols="5">
              <v-text-field outlined dense label="*頭銜" v-model="dialog.form.title"
                :rules="[dialog.rules.required, dialog.rules.symbol]"></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="5">
              <v-text-field outlined dense label="*公司" v-model="dialog.form.company"
                :rules="[dialog.rules.required, dialog.rules.symbol]"></v-text-field>
            </v-col>
          </v-row>
          <!-- ext & room -->
          <v-row no-gutters justify="space-between">

            <v-col cols="5">
              <v-text-field outlined dense label="*分機" v-model="dialog.form.ext"
                :rules="[dialog.rules.required, dialog.rules.symbol]"></v-text-field>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="5">
              <v-text-field outlined dense label="*空間" v-model="dialog.form.room"
                :rules="[dialog.rules.required, dialog.rules.symbol]"></v-text-field>
            </v-col>
          </v-row>
          <!-- url  -->
          <v-row no-gutters justify="space-between">
            <v-text-field outlined dense label="個人網頁" v-model="dialog.form.url"></v-text-field>
          </v-row>
          <!-- e-mail -->
          <v-row no-gutters justify="space-between">
            <v-text-field outlined dense label="*E-mail" v-model="dialog.form.mail"
              :rules="[dialog.rules.required]"></v-text-field>
          </v-row>
          <!-- img -->
          <v-row no-gutters>
            <v-file-input chips dense outlined accept="image/png, image/jpeg,image/jpg"
              append-outer-icon="mdi-file-find " prepend-icon prepend-inner-icon="mdi-paperclip " label="*上傳照片"
              show-size :rules="[dialog.rules.required, dialog.rules.size]" @click:append-outer="dialog.form.img != null
  ? openImg(dialog.form.showImg)
  : () => { }" @change="handleImage"></v-file-input>
          </v-row>
          <!-- specialty1 -->
          <v-row no-gutters>
            <v-textarea outlined name="input-7-4" label="專長" v-model="dialog.form.specialty1"></v-textarea>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" text @click="controllDialog(false, 0, '', 'info')">
            Cancel
          </v-btn>
          <v-btn color="indigo darken-1" text @click="dialog.mode == 0 ? createTeacher() : saveTeacher();">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- snackbar -->
    <v-snackbar v-model="snackbar.show">
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar.show = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  name: "App",

  components: {},

  data: () => ({
    testMode: 1,
    overlay: false,
    domain: "",
    tab: 0,
    seacher: "",
    seacherState: 1,
    now: "",
    isActive: false,
    resultTeachers: [],
    allTeachers: [],
    currentFTTeachers: [],
    currentPTTeachers: [],
    currentJTTeachers: [],
    currentInTTeachers: [],
    currentIdTTeachers: [],
    showAllTeachers: [],
    currentDataIndex: 0,
    imgUploadList: [],
    dialog: {
      //0:create 1:edit
      mode: 0,
      show: false,
      index: 0,
      type: "info",
      msg: "",
      form: {
        name: "",
        ext: "",
        room: "",
        title: "",
        mail: "",
        url: "",
        specialty1: [],
        company: "",
        img: null,
        showImg: ""
      },
      rules: {
        required: (value) => !!value || "Required.",
        symbol: (value) =>
          !/[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im.test(value) || "請不要輸入符號",
        upAndNumber: (value) => /^[A-Z\d]*$/.test(value) || "請輸入大寫與數字",
        size: (file) => !file || !(file.size > 2_097_152) || "照片不能大於2MB",
      },
    },
    snackbar: {
      show: false,
      text: "",
    },
    sessionTimerInterval: null
  }),
  created() {
    const self = this;
    if (
      location.href.indexOf("localhost") != -1 ||
      location.href.indexOf("81") != -1
    )
      self.testMode = 1;
    else self.testMode = 0;
  },
  mounted() {
    const self = this;
    self.mainProcess();
  },
  updated() {
    const self = this;
  },
  computed: {},

  methods: {
    mainProcess: async function () {
      const self = this;
      try {
        self.overlay = true;
        await self.checkSession();
        Promise.all([
          self.getCurrentTeachersData(1),
          self.getCurrentTeachersData(2),
          self.getCurrentTeachersData(3),
          self.getCurrentTeachersData(4),
          self.getCurrentTeachersData(5),
          self.getDomain()
        ]).then((result) => {
          self.currentFTTeachers = result[0].sort((a, b) => a.order - b.order);
          self.currentPTTeachers = result[1].sort((a, b) => a.order - b.order);
          self.currentJTTeachers = result[2].sort((a, b) => a.order - b.order);
          self.currentInTTeachers = result[3].sort((a, b) => a.order - b.order);
          self.currentIdTTeachers = result[4].sort((a, b) => a.order - b.order);
          self.domain = result[5];
        });
        // var tmpAry = await self.getCurrentTeachersData(1);
        // self.currentTeachers = tmpAry.sort((a, b) => a.order - b.order);
        self.allTeachers = await self.getAlllTeachersData();
        self.overlay = false;
        self.sessionTimer();
      } catch (error) {
        throw new Error(error);
      }
    },
    getCurrentTeachersData: function (type) {
      const self = this;
      return new Promise((resolve, reject) => {
        if (self.testMode)
          axios
            .get("./create_teacher/tools/json/fulltime-data.json")
            .then((response) => {
              if (response.data.result == 1) resolve(response.data.data);
              else {
                console.log("error: result");
                reject();
              }
            })
            .catch((e) => {
              console.log("error: ", e);
              reject(e);
            });
        else
          axios
            .post("./getJson.php", { type: type })
            .then((response) => {
              if (response.data.result == 1) resolve(response.data.data);
              else {
                console.log("error: result");
                reject();
              }
            })
            .catch((e) => {
              console.log("error: ", e);
              reject(e);
            });
      });
    },
    getAlllTeachersData: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("https://lg.dyu.edu.tw/search_teacher.php")
          .then((response) => {
            resolve(response.data);
          })
          .catch((e) => {
            console.log("error: ", e);
            reject(e);
          });
      });
    },
    searchKeyWorld: function () {
      const self = this;
      var item = self.fillterTeachers();
      self.resultTeachers = item.ary;
      self.seacherState = item.state;
    },
    fillterTeachers: function () {
      const self = this;
      var state = 1;
      let tmpAry = [];
      var keyword = self.seacher;

      if (keyword && keyword.length != 0) {
        self.updateTime();
        tmpAry = self.allTeachers.filter(
          (item) =>
            item.name.indexOf(keyword) != -1 || item.teno.indexOf(keyword) != -1
        );
        if (tmpAry.length != 0) state = 0;
        else state = 2;
      } else state = 1;

      return { ary: tmpAry, state: state };
    },
    //time
    updateTime: function () {
      const self = this;
      var date = new Date();
      self.now = date;
    },
    compareTime: function (time1, time2) {
      return new Date(time1) > new Date(time2);
    },
    //array  action
    addCurrentAry: function (item, type) {
      const self = this;
      switch (type) {
        case 1:
          if (self.currentFTTeachers.length != 0)
            var index = self.currentFTTeachers.length - 1;
          else var index = 0;

          var teacher = {
            userId: item.userid,
            order: index == 0 ? 0 : self.currentFTTeachers[index].order + 1,
            epno: item.teno,
            name: item.name,
            title: null,
            img: null,
            startdate: "2018/08/01 00:00:00",
            enddate: "2999/07/31 23:59:59",
            global: true,
          };
          self.currentFTTeachers.push(teacher);
          break;
        case 2:
          if (self.currentPTTeachers.length != 0)
            var index = self.currentPTTeachers.length - 1;
          else var index = 0;

          var teacher = {
            userId: item.userid,
            order: index == 0 ? 0 : self.currentPTTeachers[index].order + 1,
            epno: item.teno,
            name: item.name,
            title: null,
            img: null,
            startdate: "2018/08/01 00:00:00",
            enddate: "2999/07/31 23:59:59",
            global: true,
          };
          self.currentPTTeachers.push(teacher);
          break;
        case 3:
          if (self.currentJTTeachers.length != 0)
            var index = self.currentJTTeachers.length - 1;
          else var index = 0;

          var teacher = {
            userId: item.userid,
            order: index == 0 ? 0 : self.currentJTTeachers[index].order + 1,
            epno: item.teno,
            name: item.name,
            title: null,
            img: null,
            startdate: "2018/08/01 00:00:00",
            enddate: "2999/07/31 23:59:59",
            global: true,
          };
          self.currentJTTeachers.push(teacher);
          break;
        case 4:
          if (self.currentInTTeachers.length != 0)
            var index = self.currentInTTeachers.length - 1;
          else var index = 0;

          var teacher = {
            userId: item.userid,
            order: index == 0 ? 0 : self.currentInTTeachers[index].order + 1,
            epno: item.teno,
            name: item.name,
            title: null,
            img: null,
            startdate: "2018/08/01 00:00:00",
            enddate: "2999/07/31 23:59:59",
            global: true,
          };
          self.currentInTTeachers.push(teacher);
          break;
        case 5:
          if (self.currentIdTTeachers.length != 0)
            var index = self.currentIdTTeachers.length - 1;
          else var index = 0;

          var teacher = {
            userId: item.userid,
            order: index == 0 ? 0 : self.currentIdTTeachers[index].order + 1,
            epno: item.teno,
            name: item.name,
            title: null,
            img: null,
            startdate: "2018/08/01 00:00:00",
            enddate: "2999/07/31 23:59:59",
            global: true,
          };
          self.currentIdTTeachers.push(teacher);
          break;
      }
    },
    removeCurrentAry: function (index, type) {
      const self = this;
      switch (type) {
        case 1:
          self.currentFTTeachers.splice(index, 1);
          break;
        case 2:
          self.currentPTTeachers.splice(index, 1);
          break;
        case 3:
          self.currentJTTeachers.splice(index, 1);
          break;
        case 4:
          self.currentInTTeachers.splice(index, 1);
          break;
        case 5:
          let uploadIndex = -1;

          self.imgUploadList.forEach((element, elIndex) => {
            if (self.currentIdTTeachers[index].img == element.name)
              uploadIndex = elIndex;
          });
          if (uploadIndex != -1)
            self.imgUploadList.splice(uploadIndex, 1);

          self.currentIdTTeachers.splice(index, 1);
          break;
      }
    },
    upCurrentAry: function (index, type) {
      const self = this;
      if (index != 0) {
        switch (type) {
          case 1:
            self.currentFTTeachers = self.swapArrayElements(
              self.currentFTTeachers,
              index - 1,
              index
            );
            break;
          case 2:
            self.currentPTTeachers = self.swapArrayElements(
              self.currentPTTeachers,
              index - 1,
              index
            );
            break;
          case 3:
            self.currentJTTeachers = self.swapArrayElements(
              self.currentJTTeachers,
              index - 1,
              index
            );
            break;
          case 4:
            self.currentInTTeachers = self.swapArrayElements(
              self.currentInTTeachers,
              index - 1,
              index
            );
            break;
          case 5:
            self.currentIdTTeachers = self.swapArrayElements(
              self.currentIdTTeachers,
              index - 1,
              index
            );
            break;
        }
      }
    },
    downCurrentAry: function (index, type) {
      const self = this;
      switch (type) {
        case 1:
          if (index != self.currentFTTeachers.length - 1) {
            self.currentFTTeachers = self.swapArrayElements(
              self.currentFTTeachers,
              index,
              index + 1
            );
          }
          break;
        case 2:
          if (index != self.currentPTTeachers.length - 1) {
            self.currentPTTeachers = self.swapArrayElements(
              self.currentPTTeachers,
              index,
              index + 1
            );
          }
          break;
        case 3:
          if (index != self.currentJTTeachers.length - 1) {
            self.currentJTTeachers = self.swapArrayElements(
              self.currentJTTeachers,
              index,
              index + 1
            );
          }
          break;
        case 4:
          if (index != self.currentInTTeachers.length - 1) {
            self.currentInTTeachers = self.swapArrayElements(
              self.currentInTTeachers,
              index,
              index + 1
            );
          }
          break;
        case 5:
          if (index != self.currentIdTTeachers.length - 1) {
            self.currentIdTTeachers = self.swapArrayElements(
              self.currentIdTTeachers,
              index,
              index + 1
            );
          }
          break;
      }
    },
    swapArrayElements: (arr, a, b) => {
      let _arr = [...arr];
      let temp = _arr[a];
      _arr[a] = _arr[b];
      _arr[b] = temp;
      return _arr;
    },
    setOrderAry: function (ary) {
      var tmp = ary;
      for (var x = 0; x < tmp.length; x++) tmp[x].order = x + 1;
      return tmp;
    },
    //person
    newPerson: function () {
      const self = this;
      self.dialog.mode = 0;
      self.clearForm();
      self.controllDialog(true, 1, "", "info");
    },
    editPerson: function (index, item) {
      const self = this;
      self.dialog.mode = 1;
      self.currentDataIndex = index;
      self.setForm(item);
      self.controllDialog(true, 1, "", "info");
    },

    //dialog
    controllDialog(state, index, msg, type) {
      const self = this;
      self.dialog.show = state;
      self.dialog.index = index;
      if (index == 0) {
        self.dialog.msg = msg;
        self.dialog.type = type;
      }
    },
    //form
    getForm: function () {
      const self = this;
      const form = self.dialog.form;
      var item;

      item = {
        name: form.name,
        ext: form.ext,
        room: form.room,
        title: form.title,
        mail: form.mail,
        url: form.url,
        company: form.company,
        img: "./members2/pic/" + form.img,
        specialty1: Array.isArray(form.specialty1)
          ? form.specialty1
          : [form.specialty1],
      };

      return item;
    },
    setForm: function (item) {
      const self = this;
      const form = self.dialog.form;
      form.name = item.name;
      form.ext = item.ext;
      form.room = item.room;
      form.title = item.title;
      form.mail = item.mail;
      form.url = item.url;
      form.company = item.company;
      form.img = item.img;
      form.showImg = form.img.indexOf("pic") != -1 ? `../../${self.domain}/${form.img}` : form.img;
      form.specialty1 = item.specialty1;
    },
    clearForm: function () {
      const self = this;
      const form = self.dialog.form;

      form.name = "";
      form.ext = "";
      form.room = "";
      form.title = "";
      form.mail = "";
      form.url = "";
      form.company = "";
      form.img = null;
      form.showImg = null;
      form.specialty1 = [];
    },
    //teacher
    createTeacher: function () {
      const self = this;
      const item = self.getForm();
      const tabIndex = self.tab;

      switch (tabIndex) {
        case 2:
          if (self.currentJTTeachers.length != 0)
            var index = self.currentJTTeachers.length - 1;
          else var index = 0;

          var teacher = {
            userId: null,
            order: index == 0 ? 0 : self.currentJTTeachers[index].order + 1,
            epno: "",
            name: item.name,
            ext: item.ext,
            room: item.room,
            title: item.name,
            mail: item.mail,
            url: item.url,
            specialty1: item.specialty1,
            company: item.company,
            img: item.img,
            startdate: "2018/08/01 00:00:00",
            enddate: "2999/07/31 23:59:59",
            global: false,
          };
          self.currentJTTeachers.push(teacher);
          self.controllDialog(false, 0, "", "info");
          self.clearForm();
          break;
        case 3:
          if (self.currentInTTeachers.length != 0)
            var index = self.currentInTTeachers.length - 1;
          else var index = 0;

          var teacher = {
            userId: null,
            order: index == 0 ? 0 : self.currentInTTeachers[index].order + 1,
            epno: "",
            name: item.name,
            ext: item.ext,
            room: item.room,
            title: item.name,
            mail: item.mail,
            url: item.url,
            specialty1: item.specialty1,
            company: item.company,
            img: item.img,
            startdate: "2018/08/01 00:00:00",
            enddate: "2999/07/31 23:59:59",
            global: false,
          };
          self.currentInTTeachers.push(teacher);
          self.controllDialog(false, 0, "", "info");
          self.clearForm();
          break;
        case 4:
          if (self.currentIdTTeachers.length != 0)
            var index = self.currentIdTTeachers.length - 1;
          else var index = 0;

          var teacher = {
            userId: null,
            order: index == 0 ? 0 : self.currentIdTTeachers[index].order + 1,
            epno: "",
            name: item.name,
            ext: item.ext,
            room: item.room,
            title: item.name,
            mail: item.mail,
            url: item.url,
            specialty1: item.specialty1,
            company: item.company,
            img: item.img,
            startdate: "2018/08/01 00:00:00",
            enddate: "2999/07/31 23:59:59",
            global: false,
          };
          self.currentIdTTeachers.push(teacher);
          self.controllDialog(false, 0, "", "info");
          self.clearForm();
          break;
      }
    },
    saveTeacher: function () {
      const self = this;
      let item;
      switch (self.tab) {
        case 3:
          item = self.currentInTTeachers[self.currentDataIndex];
          break;
        case 4:
          item = self.currentIdTTeachers[self.currentDataIndex];
          break;
        default:
          self.controllDialog(true, 0, "somthing wrong!", "error");
          break;
      }

      let formData = self.getForm();
      item.name = formData.name;
      item.ext = formData.ext;
      item.room = formData.room;
      item.title = formData.title;
      item.mail = formData.mail;
      item.url = formData.url;
      item.company = formData.company;
      item.img = formData.img;
      item.specialty1 = formData.specialty1;

      self.controllDialog(false, 0, "", "info");
    },
    //save
    saveData: function (type) {
      const self = this;

      switch (type) {
        case 1:
          self.currentFTTeachers = self.setOrderAry(self.currentFTTeachers);
          axios
            .post("./createJson.php", {
              type: 1,
              teachers: self.currentFTTeachers,
            })
            .then((response) => {
              if (response.data.result == 1) {
                self.controllDialog(true, 0, "儲存成功", "info");
              } else {
                self.controllDialog(
                  true,
                  0,
                  "儲存失敗" + result.data.msg,
                  "error"
                );
              }
            });
          break;
        case 2:
          self.currentPTTeachers = self.setOrderAry(self.currentPTTeachers);
          axios
            .post("./createJson.php", {
              type: 2,
              teachers: self.currentPTTeachers,
            })
            .then((response) => {
              if (response.data.result == 1) {
                self.controllDialog(true, 0, "儲存成功", "info");
              } else {
                self.controllDialog(
                  true,
                  0,
                  "儲存失敗" + result.data.msg,
                  "error"
                );
              }
            });
          break;
        case 3:
          self.currentJTTeachers = self.setOrderAry(self.currentJTTeachers);
          axios
            .post("./createJson.php", {
              type: 3,
              teachers: self.currentJTTeachers,
            })
            .then((response) => {
              if (response.data.result == 1) {
                self.controllDialog(true, 0, "儲存成功", "info");
              } else {
                self.controllDialog(
                  true,
                  0,
                  "儲存失敗" + result.data.msg,
                  "error"
                );
              }
            });
          break;
        case 4:
          self.currentInTTeachers = self.setOrderAry(self.currentInTTeachers);
          axios
            .post("./createJson.php", {
              type: 4,
              teachers: self.currentInTTeachers,
            })
            .then((response) => {
              if (response.data.result == 1) {
                self.controllDialog(true, 0, "儲存成功", "info");
              } else {
                self.controllDialog(
                  true,
                  0,
                  "儲存失敗" + result.data.msg,
                  "error"
                );
              }
            });
          break;
        case 5:
          self.currentIdTTeachers = self.setOrderAry(self.currentIdTTeachers);
          let createJson = () => {
            return new Promise((resolve, reject) => {
              axios
                .post("./createJson.php", {
                  type: 5,
                  teachers: self.currentIdTTeachers,
                })
                .then((response) => {
                  resolve(response.data);
                });
            });
          };

          let tmpUploadList = [];
          tmpUploadList = self.imgUploadList.filter(item => {
            let result = false;
            self.currentIdTTeachers.forEach(teacher => {
              if (teacher.img.indexOf(item.name) != -1)
                result = true;
            });
            return result;
          });

          let form = new FormData();
          let names = [];
          tmpUploadList.forEach(element => {
            names.push(element.name);
            form.append('imgs[]', element.file);
          });
          form.append('names', names);

          let uploadImgList = () => {
            return new Promise((resolve, reject) => {
              axios
                .post("./imgUpload.php", form)
                .then((response) => {
                  resolve(response.data);
                });
            })
          };

          Promise.all([createJson(), uploadImgList()]).then(responses => {
            if (responses[0].result == 1) {
              self.controllDialog(true, 0, "儲存成功", "info");
              clearInterval(self.sessionTimerInterval);
              self.mainProcess();
            } else {
              self.controllDialog(
                true,
                0,
                "儲存失敗" + responses[0].msg,
                "error"
              );
            }
          });
          break;
        default:
          break;
      }
    },
    //image
    openImg: function (data) {
      const self = this;
      var image = new Image();
      image.src = data;
      var w = window.open("");
      w.document.write(image.outerHTML);
    },
    deleteImg: function (fileName) {
      const self = this;
      axios.post('./deleteTempImg.php', {
        fileName: fileName
      }).then(response => {
        if (response.data.result == 1) {
          self.controllDialog(false, 0, '', 'info');
        } else {
          self.controllDialog(false, 0, '', 'info');
          self.controllDialog(true, 0, "照片暫存檔刪除失敗", "error");
        }
      }).catch(e => {
        console.log(e);
        self.controllDialog(true, 0, "照片暫存檔刪除失敗", "error");
      });
    },
    handleImage: function (file) {
      const self = this;
      let fileExist = !!file;
      if (fileExist) {
        let sizeLimit = !(file.size > 2_097_152);
        if (sizeLimit) {
          var file

          let time = new Date().toISOString().replace(/T|\:|\.|\-|Z/gi, "");
          let fileName = `${self.domain + time}.jpg`;
          self.imgUploadList.push({
            name: fileName,
            file: file
          });


          self.dialog.form.img = fileName;
          self.dialog.form.showImg
            = URL.createObjectURL(file);
        } else {
          self.snackbar.text = "照片大小不能超過2MB!";
          self.snackbar.show = true;
        }
      }
    },
    createBase64Image: function (fileObj) {
      const self = this;
      const reader = new FileReader();
      reader.onload = () => {
        self.dialog.form.img = reader.result;
      };
      reader.readAsDataURL(fileObj);
    },
    //url
    goHome: function () {
      location.href = "http://wm.dyu.edu.tw/manage/index.php";
    },
    //session
    sessionTimer: function () {
      const self = this;
      if (!self.testMode)
        self.sessionTimerInterval = setInterval(() => {
          self.touchSession();
        }, 60000);
    },
    touchSession: function () {
      axios.get("./session_start.php");
    },
    checkSession: function () {
      return new Promise((resolve, reject) => {
        const self = this;
        if (!self.testMode)
          axios
            .get("./checkSession.php")
            .then((response) => {
              if (response.data.result != 1) {
                //dialog message
                self.controllDialog(true, 0, "請先登入", "error");

                //back to index
                setTimeout(() => {
                  location.href = "http://wm.dyu.edu.tw/manage/index.php";
                }, 5000);
              } else {
                resolve(response.data);
              }
            })
            .catch((e) => {
              console.log(e);
              self.controllDialog(false, 0, "發生錯誤", "error");
              reject(e);
            });
        else resolve("sucess");
      });
    },
    getDomain: function () {
      const self = this;
      return new Promise(
        (resolve, reject) => {
          if (!self.testMode)
            axios
              .get("./getDomain.php")
              .then((response) => {
                if (response.data.result != 1) {
                  //dialog message
                  self.controllDialog(true, 0, "請先登入", "error");

                  //back to index
                  setTimeout(() => {
                    location.href = "http://wm.dyu.edu.tw/manage/index.php";
                  }, 5000);
                } else {
                  resolve(response.data.data);
                }
              })
              .catch((e) => {
                console.log(e);
                self.controllDialog(false, 0, "發生錯誤", "error");
                reject(e);
              });
          else resolve("sucess");
        }
      );
    }
  },
};
</script>
